class MultiLvlContentNav {
    constructor() {
        this.elements = {
            $lists: $('.multi-lvl-content-nav__lvl1-link, .single-lvl-content-nav__lvl1'),
            $links: $('.multi-lvl-content-nav__lvl1-item')
        };
    }

    registerEvents() {
        $(window).on('resize', this.onWindowResize.bind(this));
    }

    listsFound() {
        return !!this.elements.$links.length;
    }

    onWindowResize() {
        this.elements.$lists.eqHeight();
        this.elements.$links.eqHeight();
    }
}

export default MultiLvlContentNav;